// extracted by mini-css-extract-plugin
export default {"AppInputContainer":"AppInput_AppInputContainer__riOM3","AppInputLabel":"AppInput_AppInputLabel__mEFKS","AppInput":"AppInput_AppInput__s-52P"};